import { SHOW_AUTH_MODAL, HIDE_AUTH_MODAL, AppAction, AuthModalTab } from '../../actions/app';
import { SELECT_TAB, Action } from './actions';

export interface State {
  currentTab: AuthModalTab;
  source?: string;
  landing?: string;
  isHeaderVisible: boolean;
}

const initState: State = {
  currentTab: 'signin',
  isHeaderVisible: true,
};

export default function reducer(state: State = initState, action: AppAction | Action): State {
  switch (action.type) {
    case SHOW_AUTH_MODAL:
      return {
        ...state,
        currentTab: action.payload.tab,
        source: action.payload.source,
        landing: action.payload.landing,
        isHeaderVisible: true,
      };
    case SELECT_TAB:
      return {
        ...state,
        currentTab: action.payload.tab,
      };
    case HIDE_AUTH_MODAL:
      return initState;
    default:
      return state;
  }
}
